export default class DefaultGameParams {
  constructor(gameid, bankId, token, homeUrl) {
    this.gameid = gameid,
    this.bankId = bankId
    this.token = token,
    this.homeUrl = homeUrl
    this.mode = 'real',
    this.lang = 'en'
  }
}